import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/.pnpm/next@15.5.9_react-dom@19.2.3_react@19.2.3__react@19.2.3_sass@1.95.0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.5.9_react-dom@19.2.3_react@19.2.3__react@19.2.3_sass@1.95.0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/public/aysoft_logo_red.svg");
